
import BoxInfoListComponent from "../../../components/box_infos/Index.vue";

export default {
  components: {
    BoxInfoListComponent
  }
}
